import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

// antd
import { Menu, Dropdown, Typography } from 'antd'
import { AppstoreOutlined } from '@ant-design/icons'

// slices
import { loginState } from '../../../login/login.slice'
// import { PRIVATE_ROUTES } from '../../../../routes'

const AppSwitcherDropdown = () => {
    const { userProfile } = useSelector(loginState)
    const navigate = useNavigate()

    const { Title } = Typography

    const homeApp = {
        name: 'Home',
        imageUrl:
            'https://pms-bucket123.s3.amazonaws.com/Home_dark_1754048350.svg',
        domain: 'https://app.softwareco.com',
        order: 0,
    }

    const apps = [homeApp, ...(userProfile?.appPermission || [])]
        .filter((app) => app.isAllowed !== false)
        .sort((a, b) => a.order - b.order)

    const menu = (
        <div style={{ width: 316, padding: 6 }}>
            <Menu
                mode="vertical"
                selectable={false}
                style={{
                    padding: '16px 0',
                    border: '2px solid #ededed',
                }}
            >
                {apps.map((app, index) => (
                    <Menu.Item
                        key={index}
                        onClick={() => {
                            window.open(
                                app.domain.startsWith('http')
                                    ? app.domain
                                    : `https://${app.domain}`,
                                '_blank'
                            )
                        }}
                        style={{
                            padding: '14px 22px',
                        }}
                    >
                        <img
                            src={app?.imageUrl}
                            alt={app?.name}
                            style={{
                                maxHeight:
                                    app?.name === 'StoryX' ||
                                    app?.name === 'Home'
                                        ? '20px'
                                        : '15px',
                                maxWidth: app?.name === 'Home' ? '60%' : '100%',
                                objectFit: 'contain',
                            }}
                        />
                    </Menu.Item>
                ))}
            </Menu>
        </div>
    )

    return (
        <Dropdown overlay={menu} trigger={['click']} placement="bottomCenter">
            <AppstoreOutlined
                style={{ fontSize: 24, marginRight: '15px', cursor: 'pointer' }}
            />
        </Dropdown>
    )
}

export default AppSwitcherDropdown
